import { Form, Row, Col, Select, Checkbox } from "antd";
import { FormInstance } from "rc-field-form";
import { useState, useEffect } from "react";
import { set } from "react-hook-form";

const { Option } = Select;

interface DeathFieldsProps {
  form: FormInstance;
  isDeathSelected: boolean;
}

const DeathFields: React.FC<DeathFieldsProps> = ({ form, isDeathSelected }) => {
  const [deathLocation, setDeathLocation] = useState<string | undefined>(
    form.getFieldValue('deathLocation')
  );
  const [hasInitialized, setHasInitialized] = useState(false);

  useEffect(() => {
    if (!hasInitialized) {
      // On initial load, sync state with form values without clearing
      const currentLocation = form.getFieldValue('deathLocation');
      setDeathLocation(currentLocation);
      setHasInitialized(true);
    } else {
      // After initialization, handle state changes normally
      if (!isDeathSelected) {
        form.setFieldsValue({
          deathLocation: undefined,
          confirmationMethod: undefined
        });
        setDeathLocation(undefined);
        console.log('clearing')
      } else {
        // If death is selected, check if deathLocation is already set
        const currentLocation = form.getFieldValue('deathLocation');
        setDeathLocation(currentLocation);
        console.log('setting', currentLocation);
      }
    }
  }, [isDeathSelected, form, hasInitialized]);

  const handleLocationChange = (value: string) => {
    setDeathLocation(value);
    if (!value) {
      form.setFieldsValue({ confirmationMethod: undefined });
    }
  };

  if (!isDeathSelected) {
    return null;
  }

  return (
    <>
      <Row align="bottom">
        <Col span={8} style={{ display: 'flex', alignSelf: 'flex-start', paddingTop: '5px' }}>
          <span style={{ fontWeight: 500 }}>Lugar de muerte</span>
        </Col>
        <Col span={8}>
          <Form.Item
            name="deathLocation"
            rules={[{ required: true, message: "Por favor seleccione el lugar de muerte" }]}
          >
            <Select 
              placeholder="Seleccionar lugar de muerte"
              onChange={handleLocationChange}
            >
              <Option value="hospital">En el hospital</Option>
              <Option value="household">En el hogar</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      {deathLocation && (
        <Row align="bottom">
          <Col span={8} style={{ display: 'flex', alignSelf: 'flex-start', paddingTop: '5px' }}>
            <span style={{ fontWeight: 500 }}>Vía de confirmación</span>
          </Col>
          <Col span={16}>
            <Form.Item
              name="confirmationMethod"
              rules={[{ 
                required: true, 
                type: 'array',
                min: 1,
                message: "Por favor seleccione al menos una vía de confirmación" 
              }]}
            >
              <Checkbox.Group>
                <Row>
                  <Col span={24}>
                    <Checkbox value="clinical_record">Expediente clínico</Checkbox>
                  </Col>
                  <Col span={24}>
                    <Checkbox value="phone">Telefónica</Checkbox>
                  </Col>
                  <Col span={24}>
                    <Checkbox value="social_work">Trabajo social</Checkbox>
                  </Col>
                </Row>
              </Checkbox.Group>
            </Form.Item>
          </Col>
        </Row>
      )}
    </>
  );
};

export default DeathFields;